const send = (eventType = 'track', eventName, data) => {
  if (!window.fbq) {
    console.log(`FbPixel: ${eventType}, ${eventName}, ${JSON.stringify(data, null, 2)}`) // eslint-disable-line
  } else {
    window.fbq(eventType, eventName, data)
  }
}

const track = (...args) => send('track', ...args)

const obj = { track, send }

export default obj
